import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  languageChangeRequest: ['id'],
  languageSuccess:['id'],
  languageFailure:['error'],
});

export const LanguageTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  current: 'ru',
  data: [
    {
      id: 'ru',
      title: 'Русский',
    },
    {
      id: 'en',
      title: 'English',
    }
  ],
  error: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = (state) => state.merge({fetching: true});

// we've successfully ...
export const success = (state, {id}) => 
  state.merge({fetching: false, error: null, current: id});

// we've had a problem ...
export const failure = (state, {error}) =>
  state.merge({fetching: false, error});


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.LANGUAGE_CHANGE_REQUEST]: request,
  [Types.LANGUAGE_SUCCESS]: success,
  [Types.LANGUAGE_FAILURE]: failure,
});
